import { GraduationCap } from "lucide-react";
import { DEGREES } from "../data/content";
import { Reveal, SectionHeading } from "./Reveal";

const Academics = () => (
  <section id="academics" data-testid="academic-credentials-section" className="py-20 sm:py-28 bg-white/60 border-y border-[#0D3B3E]/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading number="04" title="Academic Background" testId="academic-background-heading" />
      <div className="grid md:grid-cols-2 gap-5">
        {DEGREES.map((d, i) => (
          <Reveal key={d.degree} delay={i * 0.07}>
            <article
              data-testid={`academic-degree-card-${i}`}
              className="group h-full bg-white border border-[#0D3B3E]/10 p-7 sm:p-9 flex flex-col transition-[border-color,transform,box-shadow] duration-500 hover:border-[#0D9488]/50 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(13,59,62,0.07)]"
            >
              <div className="flex items-start justify-between gap-4 mb-6">
                <span className="flex items-center justify-center w-11 h-11 rounded-full bg-[#0D3B3E]/[0.05] text-[#0D9488] group-hover:bg-[#0D9488] group-hover:text-white transition-colors duration-500">
                  <GraduationCap className="w-5 h-5" />
                </span>
                <span className="font-display font-bold text-3xl text-[#0D3B3E]/15 group-hover:text-[#0D9488]/40 transition-colors duration-500">
                  {d.year}
                </span>
              </div>
              <h3 className="font-display font-semibold text-xl sm:text-2xl text-[#0D3B3E] leading-snug tracking-tight">
                {d.degree}
              </h3>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">{d.institution}</p>
              <p className="mt-6 pt-4 border-t border-[#0D3B3E]/10 text-[10px] font-mono tracking-[0.2em] text-[#0D9488]">
                {d.location}
              </p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Academics;
